import React, { useState, useEffect, useCallback } from "react";
import { Search } from "lucide-react";
import { debounce } from "lodash";
import { Input } from "../../../components/ui/Input";

export default function SearchBar({ produits = [], setProduitsFiltres, setProduitsFiltrés }) {
  const [searchTerm, setSearchTerm] = useState("");
  const updateFiltres = setProduitsFiltres || setProduitsFiltrés;

  // Fonction debounce
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((value) => {
      if (!updateFiltres) return;
      if (!value) {
        updateFiltres(produits);
      } else {
        const filtered = (produits || []).filter((prod) =>
          Object.values(prod).some(
            (val) =>
              val &&
              val.toString().toLowerCase().includes(value.toLowerCase())
          )
        );
        updateFiltres(filtered);
      }
    }, 200),
    [produits, updateFiltres]
  );

  useEffect(() => {
    debouncedSearch(searchTerm);
    return () => debouncedSearch.cancel();
  }, [searchTerm, debouncedSearch]);

  return (
    <div className="relative w-full">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-subtle pointer-events-none z-10" />
      <Input
        type="text"
        placeholder="Rechercher un produit..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-9 bg-surface-muted border-tertiary shadow-sm text-sm"
      />
    </div>
  );
}
